import { Button } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { DevicesAPI } from 'api/DevicesAPI';
import { useEnsureContext } from 'common/hooks';
import { BusinessPartnerContext } from 'pages/BusinessPartnerManagement/BusinessPartnerContext';
import React, { FC } from 'react';
import { useMutation } from 'react-query';
import { FormattedMessage } from 'react-intl';

type DownloadDeviceTokensCsvFileButtonProps = Omit<
  ButtonProps,
  'onClick' | 'loading' | 'href'
>;

export const DownloadDeviceTokensCsvFileButton: FC<DownloadDeviceTokensCsvFileButtonProps> = ({
  ...buttonProps
}) => {
  const bpContext = useEnsureContext(BusinessPartnerContext);
  const [mutate, { isLoading }] = useMutation(DevicesAPI.getTokensCsvFile);

  return (
    <Button
      id="button-download-device-tokens-csv"
      type="primary"
      loading={isLoading}
      onClick={() =>
        mutate(bpContext.id, {
          onSuccess: (res) => {
            const element = document.createElement('a');
            element.href = URL.createObjectURL(new Blob([res]));
            element.download = 'devices-tokens.csv';
            document.body.appendChild(element);
            element.click();
            element.remove();
          },
        })
      }
      {...buttonProps}
    >
      <FormattedMessage
        id="devices.downloadTokens"
        values={{ format: 'CSV' }}
      />
    </Button>
  );
};
